import { getOrderPassengerPoints } from "../../../../../../../redux/constants/OrdersPage/order";
import { getHumanReadableNameCellHelper } from "../../../../../../../utils";

import type { Order, Language } from "../../../../../../../services";

const cellProcessing = (item: Order.Model, language: Language): string => {
	const points = getOrderPassengerPoints(item) ?? [];
	const lastPoint = points.at(-1);
	return getHumanReadableNameCellHelper(lastPoint?.sector?.name, language);
};

export default cellProcessing;
